// Template 8 — "Class Dark RTL" — Template 6 (dark charcoal) in mirrored layout
// (content + course card swap sides, text left-aligned). Premium emerald accent.
import Template6 from "./Template6";

export default function Template8(props) {
  return <Template6 {...props} mirror signature="#10B981" signature2="#F43F5E" />;
}
